import { useApiSend } from "#hooks/useApiSend"
import { STATUS } from "#savings-fund/constants"
import { UseSavingsFundContext } from "#savings-fund/contexts/contexts"
import { savingsFundPut } from "#savings-fund/services/Api"
import { Stack, Typography } from "@mui/material"
import { useCallback, useMemo, useState } from "react"
import InputDateSaving from "../InputDateSaving"

const { MasterDialog } = require("#common/Dialog/Dialog")

export function DialogExit({ open, setOpen = () => {} }) {
	const { refreshData, colaborador } = UseSavingsFundContext()
	const success = useCallback(() => {
		refreshData()
	}, [refreshData])
	const { fetch, cancelar } = useApiSend(savingsFundPut, { success })
	const [disabled, setDisabled] = useState(false)
	const [dateExit, setDateExit] = useState("")
	const buttons = useMemo(
		() => [
			{
				label: "cancelar",
				disabled,
				onClick: () => {
					setDisabled(true)
					cancelar()
				},
			},
			{
				label: "aceptar",
				onClick: () => fetch({ colaborador, status: STATUS.SALIO, dateExit }),
			},
		],
		[cancelar, colaborador, dateExit, disabled, fetch]
	)
	return (
		<MasterDialog
			maxWidth="sm"
			open={open}
			onClose={() => {
				setOpen(false)
			}}
			title="Salir Caja De Ahorro"
			buttons={buttons}
		>
			<Stack spacing={2} justifyContent="center" alignItems="center">
				<Typography variant="h7" color="error" align="center">
					<strong>¿Está seguro de que desea concluir su participación?</strong>
					<br />
					No podrá ingresar nuevamente hasta la próxima apertura de la caja de
					ahorros.
				</Typography>
				<InputDateSaving
					label={"Selecciona la fecha de salida"}
					value={dateExit}
					setValue={setDateExit}
				/>
			</Stack>
		</MasterDialog>
	)
}
